import React from 'react';
import './circle-checkbox.scss';

const CircleCheckbox = ({ label, input, ...rest }) => (
    <div className="CircleCheckbox">
        <div className="round">
            <input {...input} {...rest} />
            <label htmlFor={rest.id} />
        </div>
        <label htmlFor={rest.id}>
            {label}
        </label>
    </div>
);

export default CircleCheckbox;
